module.exports = __webpack_public_path__ + "static/media/Down.997e53a3.svg";